<template>
  <BaseTableWrapper>
    <template #top-buttons>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse" class="mt-2">
          <RelationFiltering @getPage="getPage($event)"></RelationFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <span v-else-if="!isLoading && items.length < 1">{{ $t('views.excmrelation.list.noRelation') }}</span>
      <table v-else class="table table-sm table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.excmrelation.list.name')}}</th>
          <th>{{$t('views.excmrelation.list.description')}}</th>
          <th>{{$t('views.excmrelation.list.userData')}}</th>
          <th>{{$t('views.excmrelation.list.dateFrom')}}</th>
          <th>{{$t('views.excmrelation.list.dateTo')}}</th>
          <th style="width: 5%"></th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>{{ item['title'] }}</td>
          <td>{{ item['description'] }}</td>
          <td>
            <router-link
              v-if="item && item.userData"
              :to="{name: 'FirmShow', params: { id: item['userData']['@id'] }}">
              {{ item['userData'].firmname1 }}
            </router-link>
          </td>
          <td>
            {{ item['dateFrom'] }}
          </td>
          <td>
            {{ item['dateTo'] }}
          </td>
          <td>
            <div class="btn-group">
              <router-link
                tag="button"
                :to="{name: 'EXCMRelationUpdate', params: { id: item['@id'] }}"
                class="fa fa-edit fa-lg btn btn-sm btn-link">
              </router-link>
              <router-link
                tag="button"
                :to="{name: 'EXCMRelationShow', params: { id: item['@id'] }}"
                class="fa fa-search fa-lg btn btn-sm btn-link">
              </router-link>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination
        v-if="view"
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '../../Layout/Pagination'
import RelationFiltering from '@/components/Dashboard/Views/excmrelation/components/RelationFiltering'

export default {
  name: 'RelationsList',
  components: {
    Loader,
    Pagination,
    BaseTableWrapper,
    RelationFiltering
  },

  watch: {
    items: function () {
      if (this.items) {
        for (let i in this.items) {
          if (this.items[i].dateFrom) {
            this.items[i].dateFrom = this.$moment(this.items[i].dateFrom).format('YYYY-MM-DD HH:mm')
          }
          if (this.items[i].dateTo) {
            this.items[i].dateTo = this.$moment(this.items[i].dateTo).format('YYYY-MM-DD HH:mm')
          }
        }
      }
    }
  },

  computed: mapGetters({
    deletedItem: 'excmrelation/del/deleted',
    error: 'excmrelation/list/error',
    items: 'excmrelation/list/items',
    isLoading: 'excmrelation/list/isLoading',
    view: 'excmrelation/list/view'
  }),

  data () {
    return {
      searchParams: {
        itemsPerPage: 10,
        state: 1
      }
    }
  },

  created () {
    let url = addParamsToQuery('e_x_c_m_relations', this.searchParams)
    this.getPage(url)
  },

  methods: mapActions({
    getPage: 'excmrelation/list/default'
  })
}
</script>
